import { render, staticRenderFns } from "./ImmediateDrawTextField.vue?vue&type=template&id=66bc4f3b&"
import script from "./ImmediateDrawTextField.vue?vue&type=script&lang=js&"
export * from "./ImmediateDrawTextField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports